import { CircularProgress, Divider, Grid, Typography } from "@mui/material";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { observer } from "mobx-react";
import React, { useContext } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { StoreContext } from "../../StoreContext";
import { ProcessState } from "../../stores/models";
import JobPanel from "./JobPanel";
import styled from "@emotion/styled";
import Fade from "@mui/material/Fade";
const Styled_LoadingProgressContainer = styled("div")(({ theme }) => ({
    height: "50%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));
const Styled_OverlayContainer = styled("div")(({ theme }) => ({
    position: "absolute",
    left: "0",
    top: "0",
    width: "calc(100%)",
    height: "calc(100%)",
    pointerEvents: "none", // do not receive events
    zIndex: 50,
    borderRadius: "1rem",
    borderWidth: "0.4rem",
    borderStyle: "dotted",
    transition: "background-color 1s ease, border-color 1s ease",
    backgroundColor: "rgba(48, 48, 48, 0.60)",
    borderColor: "rgb(255, 255, 255, 0.80)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));
const PANEL_BK_NORMAL = "#fff"; // "var(--clr-white)";
const PANEL_BK_ALT = "#ebf6fb"; // "var(--clr-blue-light-2)";
const keyTypes = ["global", "keyDate"];
const JobPanels = observer(() => {
    const context = useContext(StoreContext);
    const [t, i18n] = useTranslation();
    const { getRootProps, isDragActive } = useDropzone({
        onDropAccepted: (files) => {
            files.forEach((file) => {
                context.rootStore.jobPanelStore.addJobPanelEntry(file);
            });
        },
    });
    const renderContent = () => {
        let panels = {};
        for (let keyType of keyTypes) {
            let panelsOfKeyType = context.rootStore.jobPanelStore.jobPanels.filter((panel) => panel.key.type == keyType);
            if (!panelsOfKeyType) {
                panelsOfKeyType = [];
            }
            panels[keyType] = panelsOfKeyType;
        }
        let overallIndex = 0;
        return (React.createElement(React.Fragment, null, keyTypes
            .filter((keyType) => panels[keyType].length > 0)
            .map((keyType, index) => {
            let panelsOfKeyType = panels[keyType];
            return (React.createElement(React.Fragment, { key: "fragment1_" + keyType },
                index > 0 ? (React.createElement(React.Fragment, null,
                    React.createElement(Divider, { sx: { marginBottom: "1.5rem", marginTop: "1rem", borderBottomWidth: 3 }, variant: "fullWidth", key: "div1_" + keyType }))) : undefined,
                React.createElement(Grid, { container: true, key: "keyType_" + keyType, spacing: 3, direction: "column", wrap: "nowrap", justifyContent: "center", alignItems: "center" }, panelsOfKeyType.map((ds, index) => {
                    let panelBackgroundColor = PANEL_BK_NORMAL;
                    if (overallIndex % 2 > 0) {
                        panelBackgroundColor = PANEL_BK_ALT;
                    }
                    overallIndex = overallIndex + 1;
                    return (React.createElement(Grid, { item: true, sx: { width: "calc(97.5%)" }, key: "jobPanelGrid_" + String(ds.id) },
                        React.createElement(JobPanel, { key: "jobPanel_" + String(ds.id), jobPanel: ds, backgroundColor: panelBackgroundColor })));
                }))));
        })));
    };
    const showOverlay = isDragActive || context.rootStore.jobPanelStore.jobPanels.length == 0;
    function renderContentContainer() {
        return (React.createElement(React.Fragment, null, context.rootStore.jobPanelStore.loadState == ProcessState.LOADING ? (React.createElement(Styled_LoadingProgressContainer, null,
            React.createElement(CircularProgress, null))) : (renderContent())));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", Object.assign({ style: { position: "absolute", left: "3rem", top: "15rem", width: "calc(100% - 5rem)", height: "calc(100% - 22rem)" } }, getRootProps({ className: "dropzone" })),
            React.createElement(Fade, { in: showOverlay, timeout: 700 },
                React.createElement(Styled_OverlayContainer, null,
                    React.createElement(Grid, { container: true, spacing: 2, direction: "row", alignItems: "center", justifyContent: "center" },
                        React.createElement(Grid, { item: true },
                            React.createElement(CloudUploadOutlinedIcon, { fontSize: "large", style: { color: "#fff" } })),
                        React.createElement(Grid, { item: true },
                            React.createElement(Typography, { style: { color: "#fff" } }, "Dateien zum Importieren hier ablegen")))))),
        renderContentContainer()));
});
export default JobPanels;
